var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fm-table-sort"},[_c('span',{class:{'fm-table-sort-active': _vm.sortType === 'asc'},on:{"click":function($event){return _vm.switchSortType('asc')}}}),_c('span',{class:{'fm-table-sort-active': _vm.sortType === 'desc'},on:{"click":function($event){return _vm.switchSortType('desc')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }